export const templateColumn = '1fr 5fr 5fr 4fr 3fr 3fr'
